import { render, staticRenderFns } from "./NosotrosView.vue?vue&type=template&id=02e8cd92&scoped=true&"
import script from "./NosotrosView.vue?vue&type=script&lang=js&"
export * from "./NosotrosView.vue?vue&type=script&lang=js&"
import style0 from "./NosotrosView.vue?vue&type=style&index=0&id=02e8cd92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e8cd92",
  null
  
)

export default component.exports